import { PlannedOrder } from "@/reducers/plannedOrdersSlice"
import i18n from "@/lib/i18n/i18n"

// Reference number lives on either field depending on how the order was
// created: manual/PDF entries use ref_number, Navigator-pulled ones carry
// their TMS transport number in transport_number.
export const orderReferenceNumber = (order: PlannedOrder): string | undefined =>
  order.metadata?.ref_number || order.metadata?.transport_number || undefined

// Timeline bars read "REF · route", collapsing to whichever half exists. The
// three bar kinds source the reference differently — planned orders from
// orderReferenceNumber, provider chains from their subtitle (which is where
// buildChainSubtitle puts the TMS number), and the Slick route bar not at all
// — so this takes the two halves already resolved. Returns "" when it has
// neither, leaving the fallback wording to the caller.
export const barLabel = (
  reference: string | undefined,
  route: string | undefined,
): string =>
  [reference, route]
    .map((part) => part?.trim())
    .filter((part) => Boolean(part))
    .join(" · ")

// Polish counts three ways: 1 zlecenie, 2-4 zlecenia, everything else zleceń —
// except the teens, which stay genitive despite ending in 2-4 (12 zleceń, not
// 12 zlecenia). i18next's plural rules carry that; translated at call time so
// the label follows the current interface language.
export const orderCountLabel = (count: number): string =>
  i18n.t("planner.labels.orderCount", { count })

// Same three ways, for the stops of a route bar segment.
export const stopCountLabel = (count: number): string =>
  i18n.t("planner.labels.stopCount", { count })
